import React, { useState } from 'react';
import {
  Block,
  Button,
  Col,
  Flex,
  Grid,
  Row,
  Spacer,
  Text,
  ThemePicker,
  useTheme,
} from 'vcc-ui';
import { Footer } from '../components/footer';
import { LiveDemo } from '../components/live-demo';
import { MarketingFluff } from '../components/marketing-fluff';
import { Topbar } from '../components/topbar';

export default function App() {
  const theme = useTheme();
  const [mobileNavIsOpen, setMobileNavIsOpen] = useState(false);
  return (
    <Flex extend={{ background: theme.color.background.primary }}>
      <Topbar
        onMobileNavClick={() => setMobileNavIsOpen((isOpen) => !isOpen)}
        mobileNavIsOpen={mobileNavIsOpen}
      />
      <Flex role="main" as="main">
        <ThemePicker variant="dark">
          <Flex
            extend={{
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'top center',
              backgroundSize: 'cover',
              backgroundImage: 'url(/bg-portrait.jpg)',
              textAlign: 'center',
              minHeight: '80vh',
              [theme.breakpoints.fromM]: {
                backgroundAttachment: 'fixed',
                height: '512px',
                minHeight: '512px',
                backgroundImage: 'url(/bg-landscape-dark.jpg)',
                backgroundSize: 'auto',
              },
            }}
          >
            <Grid>
              <Row>
                <Col>
                  <Spacer size={{ default: 10, fromM: 14 }} />
                  <Text as="h1" variant="peary">
                    VCC UI React
                  </Text>
                  <Spacer size={5} />
                  <Text as="h2" variant="hillary">
                    A React framework & component library for building web user
                    interfaces at Volvo Cars
                  </Text>
                  <Spacer size={5} />
                </Col>
              </Row>
              <Row>
                <Col>
                  <Flex
                    extend={{
                      [theme.breakpoints.fromM]: {
                        flexDirection: 'row',
                        justifyContent: 'center',
                      },
                    }}
                  >
                    <Block>
                      <Button href="/docs/setup" intent="primary">
                        Get Started
                      </Button>
                    </Block>
                    <Spacer />
                    <Block>
                      <Button intent="secondary" variant="outline" href="/docs">
                        View Docs
                      </Button>
                    </Block>
                    <Spacer />
                  </Flex>
                </Col>
              </Row>
            </Grid>
          </Flex>
        </ThemePicker>
        <MarketingFluff />
        <ThemePicker variant="dark">
          <LiveDemo />
        </ThemePicker>
      </Flex>
      <Footer />
    </Flex>
  );
}
